import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { clearCredentials } from '../lib/auth';

interface Props {
  children: ReactNode;
}

export default function Layout({ children }: Props) {
  function handleLogout() {
    clearCredentials();
    window.location.reload();
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-8">
              <span className="text-lg font-bold text-gray-900">Athilio Admin</span>
              <nav className="hidden sm:flex gap-6">
                <NavLink
                  to="/users"
                  className={({ isActive }: { isActive: boolean }) =>
                    `text-sm font-medium pb-0.5 border-b-2 ${
                      isActive
                        ? 'text-indigo-600 border-indigo-600'
                        : 'text-gray-500 border-transparent hover:text-gray-900 hover:border-gray-300'
                    }`
                  }
                >
                  Users
                </NavLink>
              </nav>
            </div>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-500 hover:text-gray-900"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
